<template lang="pug">
.form-check.dawn-checkbox(:class='{ "inline-": $parent.$attrs["inline"] !== undefined, "dawn-checkbox--disabled": disabled }')
  label.form-check-label(:class='{ "remove-only": removeOnly }' ref='optionWrapper')
    input.form-check-input(
      :id='optionLabel'
      :name='name'
      type='checkbox'
      :checked='optionStatus'
      :value='optionStatus'
      v-bind='$props'
      @click='changeStatus'
      :disabled='disabled'
      v-if='!removeOnly'
    )
    span.check-mask(v-if='!removeOnly')
    span.text(v-if='!$slots.default' :title='tooltip' ref='optionLabel')
      i(v-if='icon' :style='{ color: iconColor }' :class='icon')
      span(v-if='icon') &nbsp;
      | {{ optionLabel }}
      i(v-if='removeOnly' @click='remove').remove-icon.fas.fa-times-circle.pull-right
    .dawn-checkbox-option-content(v-else)
      slot
</template>

<script>

import { Eved, EventBus } from '@/event-bus'

export default {
  name: 'checkbox',
  props: {
    value: [Boolean, Array],
    optionIndex: Number,
    optionLabel: String,
    optionStatus: Boolean,
    name: String,
    disabled: Boolean,
    removeOnly: Boolean,
    error: Boolean,
    icon: String,
    iconColor: String
  },
  data() {
    return {
      tooltip: ''
    }
  },
  computed: {
    _optionStatus: function() {
      return this.optionStatus
    },
    _optionLabel: function() {
      return this.optionName
    },
    _optionIndex: function() {
      return this.optionIndex
    }
  },
  mounted() {
    this.tooltip = this.$refs.optionLabel.getBoundingClientRect().width > this.$refs.optionWrapper.clientWidth - 10
      ? this.optionLabel
      : null
  },
  methods: {
    changeStatus: function(e) {
      EventBus.$emit('changeStatus', {
        'idx': this._optionIndex,
        'status': !this._optionStatus,
        'value': e.target.checked
      })
      //
      this.$emit('change-status', e.target.checked)
      this.$emit('input', e.target.checked || '')

      e.target.checked && EventBus.$emit(Eved.GENERIC.SELECTED_CHECKBOX, this.optionLabel)
    },
    remove() {
      this.changeStatus({
        target: {
          checked: false
        }
      })
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.theme.skin .form-group .form-check-label,
.form-check-label {
  padding-left: 0;
  margin-bottom: 0;
  font-weight: $font-weight-normal;
  font-size: $font-size-xsmall;
  //@include theme { color: v(primary-04) }
  cursor: pointer;

  .text {
    @include theme { color: v(ink) }
    padding-left: 4px;
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }
  &.remove-only {
    cursor: default;
    display: inline-block;
    width: 90%;
  }
}

.dawn-checkbox {
  .form-check-input {
    @include form-field;
    @include dawn-checkbox;
  }
  &.inline {
    display: inline-block;
    margin-left: 1em;
  }
  &.inline- {
    display: inline;
    margin-right: 1em;
  }

  .remove-icon {
    line-height: 2.2em;
    cursor: pointer;
  }
}
.dawn-checkbox--disabled {
  pointer-events: none;
  opacity: 0.6;
}

</style>



// WEBPACK FOOTER //
// src/core/components/edCheckbox/checkbox.vue